import { LoanApprovalService } from '@/modules/global-settings/loan-origination/services/security-policies/loan-approval-settings.service';
import { make } from 'vuex-pathify';
// Create a new instance of the LoanApprovalService class
const loanApprovalService = new LoanApprovalService();
// Define the state of the module
export const state = {
  loanApprovalSettings: [],
  loanApprovalSetting: []
};
// Define the mutations of the module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the module
export const actions = {
  /**
   * Fetches the loan approval settings
   * @async
   * @param {object} commit - vuex commit
   * @returns {number} status - status of the request
   * @private This will ste the state of the loan approval settings
   */
  async fetchLoanApprovalSettings({ commit }) {
    const result = await loanApprovalService.fetchLoanApprovalSettings();
    if (result.status == 200) {
      commit('SET_LOAN_APPROVAL_SETTINGS', result.data);
    }
    return result.status;
  },

  /**
   * Fetches the loan approval setting by id
   * @async
   * @param {object} commit - vuex commit
   * @param {number} id - id of the loan approval setting
   * @returns {number} status - status of the request
   * @private This will set the state of the loan approval setting
   */
  async fetchLoanApprovalSetting({ commit }, id) {
    const result = await loanApprovalService.fetchLoanApprovalSetting(id);
    if (result.status == 200) {
      commit('SET_LOAN_APPROVAL_SETTING', result.data);
    }
    return result.status;
  },

  /**
   * Creates a new loan approval setting
   * @async
   * @param {object} dispatch - vuex dispatch
   * @returns {number} status - status of the request
   * @private This will dispatch the fetchLoanApprovalSettings action
   */
  async createLoanApprovalSetting({ dispatch }) {
    const result = await loanApprovalService.createLoanApprovalSetting();
    if (result.status == 201) {
      dispatch('fetchLoanApprovalSettings');
    }
    return result.status;
  },

  /**
   * Updates the loan approval loan type setting
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {object} payload - payload of the loan approval loan type setting
   * @param {number} payload.id - id of the loan approval loan type setting
   * @param {object} payload.updates - updates of the loan approval loan type setting
   * @returns {number} status - status of the request
   * @private This will dispatch the fetchLoanApprovalSettings action
   */
  async updateLoanApprovalLoanTypeSetting({ dispatch }, { id, updates }) {
    const result = await loanApprovalService.updateLoanApprovalLoanTypeSetting(
      id,
      updates
    );
    if (result.status == 200) {
      dispatch('fetchLoanApprovalSettings');
    }
    return result.status;
  },

  /**
   * Updates the loan approval level setting
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {object} payload - payload of the loan approval level setting
   * @param {number} payload.id - id of the loan approval level setting
   * @param {object} payload.updates - updates of the loan approval level setting
   * @returns {number} status - status of the request
   * @private This will dispatch the fetchLoanApprovalSettings action
   */
  async updateLoanApprovalLevelSetting({ dispatch }, { id, updates }) {
    const result = await loanApprovalService.updateLoanApprovalLevelSetting(
      id,
      updates
    );
    if (result.status == 200) {
      dispatch('fetchLoanApprovalSettings');
    }
    return result.status;
  }
};
// Define the getters of the module
export const getters = {
  approvalLevels: (state) =>
    state.loanApprovalSettings.map(
      ({ name, levelActive, approvalLevel, id }) => ({
        name,
        levelActive,
        approvalLevel,
        id
      })
    )
};
